import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import {
  Divider,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
} from '@mui/material';
import { ChevronLeft as ChevronLeftIcon } from '@mui/icons-material';

import { Drawer } from './style';
import { menuList } from './sideBar.constants';
import { layoutAction } from '../../store/sideBarStore/layoutStore';
import { sideBarSelector } from '../../store/selectors';
import { useAppActions, useAppSelector } from '../../utils/hooks';
import { permissionsCheck } from '../../utils/permission';

export const SideBar = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const { hideSideBar } = useAppActions(layoutAction);
  const isOpen = useAppSelector(sideBarSelector);

  return (
    <Drawer variant="permanent" open={isOpen} sx={{ height: '100vh' }}>
      <Toolbar
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          px: [1],
        }}
      >
        <IconButton onClick={() => hideSideBar()}>
          <ChevronLeftIcon />
        </IconButton>
      </Toolbar>

      <Divider />

      <List component="nav" sx={{ overflow: 'auto' }}>
        {menuList.map((it: any) => {
          const currentPath = location.pathname;
          const { permission, path, icon, label } = it;

          if (permission && !permissionsCheck([permission])) {
            return;
          }

          const isSelected = currentPath === path || currentPath.startsWith(path + '/');

          return (
            <Link
              key={path}
              to={path}
              style={{
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              <ListItemButton sx={{ padding: '8px 16px 8px 20px' }} selected={isSelected}>
                <ListItemIcon sx={{ minWidth: '52px' }}>{icon}</ListItemIcon>
                <ListItemText primary={t(`ui.menu.${label}`)} />
              </ListItemButton>
            </Link>
          );
        })}
      </List>
    </Drawer>
  );
};
